import './NumberInput.scss';

import NumberPicker from 'components/NumberPicker/NumberPicker';
import React from 'react';
import type { RegisterOptions } from 'react-hook-form';
import { Controller, useFormContext } from 'react-hook-form';

import type { InputNoteConfig } from '../_common';
import {
  getHookFieldClass,
  getHookGroupClass,
  renderErrorMessage,
  renderHookInputHeader
} from '../_common';

interface NumberInputProps {
  label?: string;
  name: string;
  placeholder?: string;
  inputNote?: InputNoteConfig;
  required?: boolean;
  options?: RegisterOptions;
  disabled?: boolean;
  min?: number;
  max?: number;
  integer?: boolean;
  suffix?: React.ReactNode;
  parser?: (value?: string) => number;
  addonAfter?: React.ReactNode;
  precisison?: number;
  hideControls?: boolean;
  hideLabel?: boolean;
}

const NumberInput = ({
  name,
  inputNote,
  label,
  required,
  options,
  placeholder,
  disabled,
  integer,
  max = 1000000,
  min,
  parser,
  suffix,
  addonAfter,
  precisison,
  hideControls,
  hideLabel
}: NumberInputProps) => {
  const { control, getFieldState, formState } = useFormContext();

  const { invalid, isDirty, error, isTouched } = getFieldState(name, formState);

  const showError = !!error && isDirty;

  return (
    <div className={getHookGroupClass(label, 'NumberInput')}>
      {!hideLabel && renderHookInputHeader(name, label, required, inputNote)}
      <Controller
        name={name}
        control={control}
        rules={options}
        render={({ field }) => (
          <NumberPicker
            {...field}
            id={name}
            placeholder={placeholder}
            className={getHookFieldClass(isTouched, invalid)}
            disabled={disabled}
            min={min}
            max={max}
            step={1}
            integer={integer}
            parser={parser}
            suffix={suffix}
            addonAfter={addonAfter}
            precisison={precisison}
            controls={!hideControls}
          />
        )}
      />
      {renderErrorMessage(showError, error?.message)}
    </div>
  );
};

export default NumberInput;
